import {
  LOAD_EVENTS_V3_FETCH,
  unloadEventsV3Action,
} from "fleet/redux-store/ui-state/events-v3/actions";
import { eventsV3Selector } from "fleet/redux-store/ui-state/events-v3/selectors";
import { EventV3List } from "fleet/view/event/events-v3-list";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { applicationsSelector } from "redux-store/applications/selectors";
import { devicesSelector } from "redux-store/devices";
import { defaultArray } from "redux-store/selectors";
import { storesReady } from "redux-store/utils";

function mapStateToProps(state) {
  const storesLoaded = storesReady(
    state.global.applications,
    state.global.devices,
  );
  const applications = applicationsSelector(state);
  const eventsV3 = eventsV3Selector(state).events || defaultArray;
  const devices = devicesSelector(state);

  return {
    applications,
    devices,
    eventsV3,
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchEventsV3: (serviceOpts) => {
      return createPromiseApiAction(dispatch, LOAD_EVENTS_V3_FETCH, [
        serviceOpts.start,
        serviceOpts.end,
        serviceOpts.filters,
      ]);
    },

    unloadEventsV3: () => {
      return dispatch(unloadEventsV3Action());
    },
  };
}

const ConnectedEventsV3List = connect(
  mapStateToProps,
  mapDispatchToProps,
)(EventV3List);

export { ConnectedEventsV3List };
